import React, { useEffect, useState } from "react";
import Hero from "../../components/Hero";
import Footer from "../../components/Footer";
import { localStorageHandler } from "../../utils/helpers";
import { CONSTANTS } from "../../constants/Constants";
import { getPackages } from "../../services/api/packages";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../context/GlobalContext";
import ProductFeature from "../../components/ProductFeature";
import AutomateHiring from "../../components/AutomateHiring";
import WhyChoose from "../../components/WhyChoose";
import PricingPackage from "../../components/PricingPackageLandingPage";
import Navbar from "../../components/Navbar";
// import RequestForm from "../../components/RequestForm";

export interface PackagesResponse {
  packageName: string;
  unitAmount: string;
  currency: string;
  metadata: {
    [key: string]: string;
  };
}
const LandingPage: React.FC = () => {
  const { setShowHeader } = useGlobalContext();
  // const [requestDemoScreen, setRequestDemoScreen] = useState<Boolean>(false)
  const [packages, setPackages] = useState<PackagesResponse[]>([]);
  const [packagesUnavailable, setPackagesUnavailable] = useState(false);

  // const [demoBtnTxt, setDemoBtnTxt] = useState("Get a demo")
  const navigate = useNavigate();

  useEffect(() => {
    setShowHeader(false)
    localStorageHandler("remove", CONSTANTS.LOCAL_STORAGE_KEYS.PACKAGE_PLAN)
    const fetchPackages = async () => {
      try {
        const response = await getPackages();
        if (response?.success && Array.isArray(response.data)) {
          setPackages(response.data);
        } else {
          setPackagesUnavailable(true);
        }
      } catch {
        setPackagesUnavailable(true);
      }
    };
    fetchPackages();

    return () => setShowHeader(true)
    // eslint-disable-next-line
  }, []);




  const packageHandler = (index: number) => {
    navigate("/sign-up")
    setShowHeader(true)
    if (index !== 0) {
      localStorageHandler(
        "set",
        CONSTANTS.LOCAL_STORAGE_KEYS.PACKAGE_PLAN,
        CONSTANTS.PREMIUM_TXT
      );
    }
  };

  const demoRequestScreenHandler = () => {
    navigate("/login")
    // setRequestDemoScreen(!requestDemoScreen)
    // setDemoBtnTxt(`${!requestDemoScreen ? "Back" : "Get a demo"}`)
  }

  return (
    <div className="!text-[#232323]">
      <Navbar
        setRequestDemoScreen={demoRequestScreenHandler}
        demoBtnTxt={"Login"}
      />
      {/* {!requestDemoScreen ? */}
        {/* <> */}
          <Hero
            journeyHandler={() => packageHandler(0)}
          />

          <ProductFeature
            journeyHandler={() => packageHandler(0)}
          />
          <AutomateHiring
            journeyHandler={() => packageHandler(0)}
          />
          <WhyChoose />
          <PricingPackage
            packages={packages}
            packageHandler={packageHandler}
            packagesUnavailable={packagesUnavailable}
          />
        {/* </> : <RequestForm />} */}
      <Footer />
    </div>
  );
};

export default LandingPage;
